// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5461": "4abfb4091f55","6863": "454c9f289029","7141": "cdec85e31733","8385": "1926c8bb4fe0",}[chunkId] + ".css"
}